import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { colors, fontSize, fontWeight } from '../../theme';

interface FormInfoTooltipProps {
    information: string;
}

const FormInfoTooltip: FC<FormInfoTooltipProps> = ({ information }) => (
    <Tooltip
        componentsProps={{
            tooltip: {
                sx: {
                    bgcolor: colors.grey100,
                    borderRadius: '4px',
                    color: colors.grey000,
                    fontSize: fontSize.sm,
                    fontWeight: fontWeight.semiRegular,
                    maxWidth: 360,
                    padding: '6px 10px',
                    '& .MuiTooltip-arrow': { color: colors.grey100 },
                },
            },
        }}
        placement="top"
        title={information}
        arrow
    >
        <InfoIcon sx={{ color: colors.grey200, cursor: 'help', fontSize: '14px', marginLeft: '4px', verticalAlign: 'middle' }} />
    </Tooltip>
);

export default FormInfoTooltip;
